import React from 'react';
import DraggableList from './../DraggableList/DraggableList';
import './RankingAllResponse.scss'


function RankingAllResponse(props) {
    return (
        <div className='response-container'>
            <DraggableList disabled={props.responseSubmitted} options={props.options} setOptions={props.setShuffledOptions} handleLockInResponse={props.handleLockInResponse} isAnswer={false}
            displayTooltip={props.displayTooltip} setDisplayTooltip={props.setDisplayTooltip}/>          
        </div>
    );
  }

export default RankingAllResponse;
